import {
  AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, Type, ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ParticleService} from "@core/services/particle.service";
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";

@Component({
    standalone: false,
    selector: 'particle-transmission-form-editor-container',
  templateUrl: './transmission-form-editor-container.component.html',
  styleUrls: ['./transmission-form-editor-container.component.scss']
})
export class TransmissionFormEditorContainerComponent implements OnInit, AfterViewInit {
  @Input() item: any;
  @Input() fieldDefinition: any;
  @ViewChild('dynamicComponent', {read: ViewContainerRef}) viewContainerRef;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private particleService: ParticleService
  ) { }

  ngOnInit() {
  }
  ngAfterViewInit(): void {
    if (this.fieldDefinition && this.fieldDefinition.cellEditor) {
      const resolvedComponent = this.particleService.getCellComponent(this.fieldDefinition.cellEditor);
      this.viewContainerRef.clear();
      const component = this.viewContainerRef.createComponent(resolvedComponent);
      const transmissionFormComponent = component.instance as CellComponent;
      transmissionFormComponent.fieldDefinition = this.fieldDefinition;
      transmissionFormComponent.item = this.item;
      transmissionFormComponent.valueChanged.subscribe(event => {
        this.valueChanged.emit(event);
      })
    }
  }
}
